import { useDisclosure, Button, Drawer, DrawerOverlay, DrawerContent, DrawerHeader, DrawerBody, DrawerFooter, Box, Flex, Grid, GridItem, Show, useColorModeValue, Tab, TabList, Tabs, FormLabel, Icon, useToast, Heading, InputGroup, InputRightAddon, Select } from '@chakra-ui/react'
import React, { ChangeEvent, forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react'
import { useData } from 'services/data/DataProvider';
import dayjs from 'dayjs';
import weekday from 'dayjs/plugin/weekday';
import { DayNote, MinimalStatistics, newDayNote, newMinStats, newTradeLogic, Trade, TradeStrategy } from 'views/trader/trades/variables/types';
import { MinimalStatProcess } from 'views/trader/trades/variables/MinimalStatProcessor';
import MinimalStatBarLarge from 'views/trader/components/display/MinimalStatBarLarge';
import MinimalStatBar from 'views/trader/components/display/MinimalStatBar';
import Card from 'components/card/Card';
import { useAuth } from 'services/auth/AuthProvider';
import DashCalendarModalChart from '../charts/DashCalendarModalChart';
import NotesTemplates from 'views/trader/trades/components/fields/NotesTemplates';
import JornoQuill from 'views/trader/components/inputs/JornoQuill';
import ImageDropzone from 'views/trader/trades/components/fields/ImageDropzone';
import { MdClose } from 'react-icons/md';
import api from 'services/api';
import { db } from 'services/db';
import TradeDrawer from 'views/trader/trades/components/modals/TradeDrawerNew';
import { saveDayNotesToDb, updateStratsAndMistakes } from 'services/dbservice';
import { updateTrade } from 'services/apiservice';
import uuid from 'react-uuid';
import DashCalendarModalDayStats from './DashCalendarModalDayStats';
import { useUpdateTradeLogicBulk } from 'views/trader/trades/hooks/useUpdateTradeLogicBulk';

const DashCalendarModalWeek = forwardRef((props: {}, ref) => {
    //const { event } = props;
    dayjs.extend(weekday);
    const { user, muuid } = useAuth();
    const tradeDrawerRef = useRef(null);
    const toast = useToast();
    const { defaultgroup, defaultcurrency, dateformat, usertradelogic } = useData();
    const [bulkUpdate, LogicBulkUpdateConfirm] = useUpdateTradeLogicBulk({});
    const { isOpen, onOpen, onClose } = useDisclosure()
    const { periodtrades, daynotes } = useData();
    const btnRef = React.useRef()
    const bgColor = useColorModeValue('white', 'navy.800');
    const cardBg = useColorModeValue('gray.200', 'navy.600');
    const textColor = useColorModeValue('gray.700', 'white');
    const textColorSecondary = useColorModeValue('secondaryGray.600', 'secondaryGray.500');
    const [tempreset, setTempreset] = useState('');

    const [stats, setStats] = useState<MinimalStatistics>(newMinStats());
    const [trades, setTrades] = useState<Trade[]>([]);
    const [dayChartTrades, setdayChartTrades] = useState<Trade[]>([]);
    const [statload, setstatload] = useState(false);
    const [selectedNote, setSelectedNote] = useState<DayNote>(newDayNote());
    const [weekDayNotes, setWeekDayNotes] = useState<DayNote[]>([]);

    const [notes, setNotes] = useState("");
    const [image, setImage] = useState<string>("");

    const [updatedStrategies, setUpdatedStrategies] = useState<any[]>([]);
    const [updatedMistakes, setUpdatedMistakes] = useState<any[]>([]);

    const [saving, setSaving] = useState(false);

    const [weekNum, setWeekNum] = useState(0);
    const [dayindex, setDayindex] = useState(0);
    const [weektitle, setWeektitle] = useState('');
    const [bias, setBias] = useState('');
    const [dayLabel, setdaylabel] = useState('SUNDAY');
    const [hideinfo, setHideinfo] = useState(false);
    const [dayTitle, setDayTitle] = useState('');

    const [userconditions, setUserConditions] = useState([]);

    useImperativeHandle(ref, () => ({
        async openModal(week: number, day: number) {
            setWeekNum(week);
            setDayindex(day);
            setdaylabel(dayjs().week(week).day(day).format('dddd').toUpperCase())
            let daytit = dayjs().week(week).day(6).format(dateformat);
            setWeektitle(daytit.substring(0, daytit.lastIndexOf(" "))) // removes time from date
            setUserConditions(usertradelogic.market_condition);
            openmodal(week);
        }
    }));


    useEffect(() => {
        setUserConditions(usertradelogic.market_condition);
    }, [usertradelogic])


    const openmodal = (weekno: number) => {
        initData(weekno)
        onOpen();
    }

    const initData = (weekno: number) => {
        setstatload(true);
        let tds = periodtrades.filter((tr: Trade) => dayjs(tr.datetime).week() === weekno)
        setTrades(tds);
        let dns = daynotes.filter((dn: DayNote) => dayjs(dn.date).week() === weekno)
        initDaysNotes(tds, dns, weekno);
    }

    const initDaysNotes = (tds: Trade[], notes: DayNote[], weekno: number) => {
        let day = 0;
        let darr = [];
        while (day < 7) {
            let dn = newDayNote();
            dn.date = dayjs().week(weekno).day(day).format('YYYY-MM-DD');
            dn.userid = user.id;
            dn.last_uuid = muuid;
            dn.groupid = defaultgroup.groupid;
            darr.push(dn);
            day++;
        }

        for (let dn of notes) {
            dn.trades = [];
            let index = dayjs(dn.date).day();
            darr[index] = JSON.parse(JSON.stringify(dn));
        }

        for (let dn of darr) {
            for (let tr of tds) {
                if (dayjs(dn.date).day() === (dayjs(tr.datetime).day())) {
                    dn.trades.push(tr.tradeid);
                }
            }
        }

        setWeekDayNotes(darr);

        //sortNotes(darr, notes);
    }

    /*const sortNotes = (initnotes: DayNote[], daynotes: DayNote[]) => {
        for (let dn of daynotes) {
            let index = dayjs(dn.date).day();
            initnotes[index] = JSON.parse(JSON.stringify(dn));
        }
        setWeekDayNotes(initnotes);

    }*/

    useEffect(() => {
        if (weekDayNotes.length > 0) {
            /*if (dayjs().week() === weekNum) {
                loadDayTrades(dayjs().day())
            }
            else {
                loadDayTrades(dayindex)
            }*/
            loadDayTrades(dayindex)
        }
    }, [weekDayNotes])



    useEffect(() => {
        setTimeout(() => { /// for smoother loading
            setTrades(trades);
            setstatload(true);
            setTimeout(async () => {
                await MinimalStatProcess(trades, "USD").then((s) => {
                    setStats(s);
                    setstatload(false);
                })
            }, 1000);
        }, 500);
    }, [trades])



    const changeTabTab = (index: number) => {
        loadDayTrades(index)
        setdaylabel(dayjs().week(weekNum).day(index).format('dddd').toUpperCase())
    }

    const loadDayTrades = async (index: number) => {
        let dnote = weekDayNotes[index];
        let trs = dnote.trades;
        let arr = trades.filter(x => trs.find(y => y === x.tradeid));
        setDayTitle(dayjs(dnote.date).format('ddd MMM D YYYY'))
        setdayChartTrades(arr);
        setSelectedNote(dnote);
        setNotes(dnote.text);
        setImage(dnote.base64Image);
        setBias(dnote.bias);

        setTempreset(uuid());
    }

    useEffect(() => {
        setHideinfo(bias !== '' || image !== '' || (notes !== '' && notes.trim() !== '<p><br></p>'));
    }, [bias, notes, image])


    const showTrade = async (tradeid: number) => {

        let tr = trades.filter((t) => t.tradeid === tradeid);
        if (tr.length) {
            tradeDrawerRef.current.openModal(tr[0]);
        }
        else {
            toast({ title: 'Oops, trade not found ...', description: "Please refresh your browser window", status: 'error', position: 'top', duration: 2000, isClosable: false });
        }
    }

    const updateBias = async (e: ChangeEvent<HTMLSelectElement>) => {
        setBias(e.target.value);
        selectedNote.bias = e.target.value;

        let res = await bulkUpdate(selectedNote.trades, e.target.value);
        if (res === 'update') {
            for (let id of selectedNote.trades) {
                db.trades.get(id).then((tr) => {
                    if (tr.trade_logic.length) {
                        tr.trade_logic[0].market_condition = e.target.value;
                    }
                    else {
                        tr.trade_logic.push(newTradeLogic())
                        tr.trade_logic[0].market_condition = e.target.value;
                    }
                    tr.sync_due = true;
                    db.trades.put(tr, tr.tradeid).catch((e) => { })
                })
            }
            //update trades locally too
            for (let tr of dayChartTrades) {
                if (tr.trade_logic.length) {
                    tr.trade_logic[0].market_condition = e.target.value;
                }
                else {
                    tr.trade_logic.push(newTradeLogic())
                    tr.trade_logic[0].market_condition = e.target.value;
                }
                tr.sync_due = true;
            }
        }
    }

    const setDayNotes = (content: string) => {
        selectedNote.text = content.trim();
        setNotes(content.trim());
    }
    const updateimage = async (file: string) => {
        setImage(file);
        selectedNote.base64Image = file;
    }

    const clearDaynotes = () => {
        setNotes('');
        setImage('');
        setBias('');
        selectedNote.text = '';
        selectedNote.base64Image = '';
        selectedNote.bias = '';
        setTempreset(uuid());
    }

    const saveAndClose = async () => {
        //alert(JSON.stringify(weekDayNotes));

        for (let dn of weekDayNotes) {
            if (dn.text.trim() === '<p><br></p>') {
                dn.text = '';
            }
            dn.last_uuid = muuid;
            delete dn.sync_due;
        }

        setSaving(true);
        closeModal();
        //await saveDayNotesToDb(daynotes, false);

        await api.post('/trade/savedaynotes', { daynotes: weekDayNotes })
            .then(async (res) => {
                await saveDayNotesToDb(res.data, false, true);
                setSaving(false);
            }).catch(async (err) => {
                setSaving(false);
                await saveDayNotesToDb(weekDayNotes, true, false); //(notes: DayNote[], sync_due: boolean, delete_empty: boolean)
                for (let n of weekDayNotes) {
                    if (n.id < 1 && (n.text.trim().length || n.base64Image.trim().length || n.bias.length)) {
                        toast({ title: 'Oops ... could not save new notes', description: "Server not responding, please try again in a few minutes", status: 'error', position: 'top', duration: 4000, isClosable: true });
                        break;
                    }
                }

            })

    }

    const addStratToUpdate = (su: TradeStrategy) => {
        setUpdatedStrategies([...updatedStrategies, su]);
        trades.forEach((tr, index) => {
            tr.strategies.forEach((s) => {
                if (s.id === su.id) {
                    if (s.name.trim() !== su.name.trim()) {
                        s.name = su.name;
                    }
                }
            })
        })
    }

    const addmisttoupdate = (mu: { name: string; id: number }) => {
        setUpdatedMistakes([...updatedMistakes, mu]);
        trades.forEach((tr, i) => {
            const index = tr.mistakes.findIndex((m: { name: string, id: number }) => m.id === mu.id);
            if (index > -1) {
                let m: { name: string, id: number } = { name: mu.name, id: mu.id }
                let mist = tr.mistakes.slice();
                tr.mistakes = [...mist.slice(0, index), m, ...mist.slice(index + 1)];
            }
        });
    }

    const updateSandMonly = async () => {
        await updateStratsAndMistakes(updatedStrategies, updatedMistakes).catch((r) => { });
    }

    const savetrade = async (trade: Trade) => {

        //setLoading(true);

        delete trade.sync_due; //only used locally

        let str = trade.notes.replace(/(<([^>]+)>)/ig, '').trim();
        if (!str.length) {
            trade.notes = "";
        }
        trade.notes = trade.notes.trim();
        trade.last_uuid = muuid;

        await updateTrade(trade).then(async (r) => {
            trade.sync_due = r;
            await db.trades.put(trade, trade.tradeid).then(async () => {
                //updatetrade(trade);
            }).catch(error => { });
        });

        updateSandMonly();
    }

    const removetrade = (tradeid: number) => {
        let trs = trades.filter((tr) => tr.tradeid !== tradeid);
        setTrades(trs);
        let ctrs = dayChartTrades.filter((tr) => tr.tradeid !== tradeid);
        setdayChartTrades(ctrs)

        let tindex = selectedNote.trades.indexOf(tradeid);
        if (tindex > -1) {
            selectedNote.trades.splice(tindex, 1);
        }

    }

    const closeModal = () => {
        setTempreset(uuid());
        onClose();
    }

    return (
        <>
            {/*<Box as={Button} height={'auto'} bg={event.event.backgroundColor} w='100%' borderRadius={'5px'} p={'10px'} _hover={{ background: 'rgba(0, 0, 0, 0.25);' }} onClick={openmodal}>
                <Flex direction={'column'} justify={'space-evenly'} h='100%'>
                    <Text fontSize={{ base: 'xs', md: 'xs' }} color={event.event.textColor}>Week {weekNum}</Text>
                    <Text fontSize={{ base: 'xs', md: 'md' }} color={event.event.textColor} mt='5px'>{event.event.title}</Text>
                    <Text fontSize={'xs'} color={event.event.textColor} mt='5px'>
                        {'(' + event.event.extendedProps.avgR.toFixed(2) + ' R)'}
                    </Text>
                </Flex>
            </Box>*/}
            <Drawer isOpen={isOpen} placement={'top'} size={'full'} onClose={closeModal} finalFocusRef={btnRef}>
                <DrawerOverlay />
                <DrawerContent bg={bgColor}>
                    {/*<DrawerCloseButton isDisabled={saving} onClick={closeModal} />*/}
                    <DrawerHeader>Week {weekNum} review  -  to {weektitle}</DrawerHeader>

                    <DrawerBody >
                        <Flex direction={'column'} gap={10}>
                            <Box w="100%" mt="10px">
                                <Show breakpoint='(min-width: 1800px)'>
                                    <MinimalStatBarLarge loading={statload} stats={stats} />
                                </Show>
                                <Show breakpoint='(max-width: 1799px)'>
                                    <MinimalStatBar loading={statload} stats={stats} />
                                </Show>
                            </Box>
                            <Flex direction={'column'} gap={0}>
                                <Show breakpoint='(min-width: 801px)'>
                                    <Tabs isFitted variant='enclosed' onChange={(index) => changeTabTab(index)} defaultIndex={dayindex}>
                                        <TabList mb='1em'>
                                            <Tab _selected={{ color: textColor, bg: cardBg }}>SUN</Tab>
                                            <Tab _selected={{ color: textColor, bg: cardBg }}>MON</Tab>
                                            <Tab _selected={{ color: textColor, bg: cardBg }}>TUE</Tab>
                                            <Tab _selected={{ color: textColor, bg: cardBg }}>WED</Tab>
                                            <Tab _selected={{ color: textColor, bg: cardBg }}>THU</Tab>
                                            <Tab _selected={{ color: textColor, bg: cardBg }}>FRI</Tab>
                                            <Tab _selected={{ color: textColor, bg: cardBg }}>SAT</Tab>
                                        </TabList>
                                    </Tabs>
                                </Show>
                                <Show breakpoint='(max-width: 800px)'>
                                    <Tabs isFitted variant='enclosed' onChange={(index) => changeTabTab(index)} defaultIndex={dayindex}>
                                        <TabList mb='1em'>
                                            <Tab _selected={{ color: textColor, bg: cardBg }}>S</Tab>
                                            <Tab _selected={{ color: textColor, bg: cardBg }}>M</Tab>
                                            <Tab _selected={{ color: textColor, bg: cardBg }}>T</Tab>
                                            <Tab _selected={{ color: textColor, bg: cardBg }}>W</Tab>
                                            <Tab _selected={{ color: textColor, bg: cardBg }}>T</Tab>
                                            <Tab _selected={{ color: textColor, bg: cardBg }}>F</Tab>
                                            <Tab _selected={{ color: textColor, bg: cardBg }}>S</Tab>
                                        </TabList>
                                    </Tabs>
                                </Show>
                            </Flex>

                            <Card w='100%' minH={'80%'} bg={cardBg} mt='-56px' borderTopRadius={0}>
                                <Grid templateColumns={{ base: 'repeat(1, 1fr)', md: 'repeat(2, 1fr)', lg: 'repeat(3, 1fr)' }} gap={6} minH={'100%'}>
                                    <GridItem colSpan={1}>
                                        <Card borderWidth={'1px'}>
                                            <Flex direction={'column'} gap={6}>
                                                <Flex justify={'center'} mt='10px'><Heading size={'sm'} fontWeight={'700'} color={textColorSecondary}>{dayTitle}</Heading></Flex>
                                                {dayChartTrades.length < 1 &&
                                                    <Flex direction={'column'} w='100%' justify={'center'} textAlign={'center'} pb={5}>
                                                        <Heading size={'sm'} color='red.500'>NO trades data for this day</Heading>
                                                        <Heading size={'xs'} color={textColor} mt='20px' hidden={hideinfo}>You can still enter notes and an image for review</Heading>
                                                    </Flex>
                                                }
                                                {dayChartTrades.length > 0 && <DashCalendarModalDayStats trades={dayChartTrades} />}
                                                <Card bg={bgColor} borderWidth='1px' hidden={dayChartTrades.length < 1}>
                                                    <DashCalendarModalChart trades={dayChartTrades} currency={defaultcurrency} opentrade={showTrade} />
                                                </Card>
                                                <Flex direction={{ base: 'column', lg: 'row' }} justify={'space-between'} mb='-15px'>
                                                    <Flex mb={{ base: '10px', lg: '0px' }}>
                                                        <InputGroup size={'sm'}>
                                                            <InputRightAddon borderRadius={5} borderRightRadius={0}>Market conditions</InputRightAddon>
                                                            <Select onChange={updateBias} value={bias}>
                                                                {/*<option value=''>Select ...</option>
                                                                <option value='Bullish'>Bullish</option>
                                                                <option value='Bearish'>Bearish</option>
                                                                <option value='Neutral'>Neutral</option>
                                                                <option value='Trending'>Trending</option>
                                                                <option value='Ranging'>Ranging</option>
                                                                <option value='Sideways'>Sideways</option>
                                                                <option value='Volatile'>Volatile</option>
                                                                <option value='NEWS event'>NEWS event</option>*/}
                                                                <option value=''>Select ...</option>
                                                                {(userconditions.length > 0) &&
                                                                    <optgroup label='User'>

                                                                        {userconditions.map((val: string) => (
                                                                            <option key={val} value={val}>
                                                                                {val}
                                                                            </option>
                                                                        ))}
                                                                    </optgroup>
                                                                }

                                                                <optgroup label='Defaults'>
                                                                    <option value='Bullish'>Bullish</option>
                                                                    <option value='Bearish'>Bearish</option>
                                                                    <option value='Neutral'>Neutral</option>
                                                                    <option value='Trending'>Trending</option>
                                                                    <option value='Ranging'>Ranging</option>
                                                                    <option value='Sideways'>Sideways</option>
                                                                    <option value='Volatile'>Volatile</option>
                                                                    <option value='NEWS event'>NEWS event</option>
                                                                </optgroup>
                                                            </Select>
                                                        </InputGroup>
                                                    </Flex>
                                                    <NotesTemplates type="day" notes={selectedNote.text} setnotes={setDayNotes} reset={tempreset} mb={'0px'} size={'sm'} />
                                                </Flex>
                                                <JornoQuill content={notes} updatecontent={setDayNotes} allowimages={false} placeHolder={'Enter day notes here ...'} />
                                            </Flex>
                                        </Card>
                                    </GridItem>
                                    <GridItem colSpan={{ base: 1, lg: 2 }} >
                                        <Flex direction={'column'} h={'100%'}>
                                            <Flex direction={'row'} justify={'space-between'}>
                                                <FormLabel fontWeight='bold' fontSize='sm' mb='-10px' mt='10px'>Day Image</FormLabel>
                                                <Flex hidden={!image.length} w="30px" h="30px" justify="center" align="center" bg={'red.500'} borderColor={'red.500'} borderWidth={'2px'} borderRadius="10px" mt='10px' mb='-10px' top="15px" right="15px" transition="0.3s" cursor="pointer" onClick={() => updateimage('')} _hover={{ background: 'rgba(0, 0, 0, 0.25);' }}>
                                                    <Icon as={MdClose} color="#fff" fontSize="20px" />
                                                </Flex>
                                            </Flex>
                                            <ImageDropzone imagefile={image} setimagefile={updateimage} />
                                        </Flex>
                                    </GridItem>
                                </Grid>
                                <Flex direction={'row'} justify={'end'} mt='10px'>
                                    <Button colorScheme='red' variant={'outline'} onClick={clearDaynotes} isDisabled={saving}>Clear {dayLabel} notes</Button>
                                </Flex>
                            </Card>

                        </Flex>
                        <TradeDrawer ref={tradeDrawerRef} addUpdatedStrategy={addStratToUpdate} addUpdatedMistake={addmisttoupdate} savetrade={savetrade} bulkupdate={false} updateSandMonly={updateSandMonly} removefromtable={removetrade}></TradeDrawer>
                        <LogicBulkUpdateConfirm />
                    </DrawerBody>
                    <DrawerFooter>
                        {/*<Button variant='outline' mr={3} onClick={closeModal} hidden={saving}>
                            Cancel
                        </Button>*/}
                        <Button colorScheme='blue' onClick={saveAndClose} isLoading={saving} loadingText='Saving'>Save and close</Button>
                    </DrawerFooter>
                </DrawerContent>
            </Drawer>

        </>
    )
})

export default DashCalendarModalWeek


